import { useState } from 'react';
import { useGetPresignedUrlMutation } from '../services/uploadFileV2';
import { trackException } from '../helpers/errorTracker';

export const useUploadFile = () => {
  const [getPresignedUrl] = useGetPresignedUrlMutation();
  const [isLoading, setIsLoading] = useState(false);

  const sendFileToS3 = (presignedUrl, remoteUrl, file) =>
    fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    })
      .then(() => remoteUrl)
      .catch((error) => {
        throw error;
      });

  const uploadFile = (file) => {
    setIsLoading(true);

    return getPresignedUrl({ fileType: 'avatar_image', fileName: file.name })
      .unwrap()
      .then(({ presignedUrl, remoteUrl }) => sendFileToS3(presignedUrl, remoteUrl, file))
      .then((remoteUrl) => {
        setIsLoading(false);
        return remoteUrl;
      })
      .catch((error) => {
        setIsLoading(false);
        trackException(error);
      });
  };

  return { uploadFile, isLoading };
};
